module.exports = __webpack_public_path__ + "img/resources.e039cca9.svg";